import { render, staticRenderFns } from "./DbRegistrations.vue?vue&type=template&id=2a57a720&scoped=true&"
import script from "./DbRegistrations.vue?vue&type=script&lang=js&"
export * from "./DbRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./DbRegistrations.vue?vue&type=style&index=0&id=2a57a720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a57a720",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a57a720')) {
      api.createRecord('2a57a720', component.options)
    } else {
      api.reload('2a57a720', component.options)
    }
    module.hot.accept("./DbRegistrations.vue?vue&type=template&id=2a57a720&scoped=true&", function () {
      api.rerender('2a57a720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/DbRegistrations.vue"
export default component.exports